import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Container } from "react-bootstrap";
import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from "axios";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../../Assets/css/reviews.css";

// import Heading from "../ui/Heading";
import leftArrow from "../../../../Assets/images/rev-images/left-arrow.svg";
import rightArrow from "../../../../Assets/images/rev-images/right-arrow.svg";
import GoogleIcon from "../../../../Assets/images/rev-images/gi.png";
import Stari from "../../../../Assets/images/rev-images/stari.png";
// import Minfo from "../../../../Assets/images/rev-images/favicon.png";
import Google from "../../../../Assets/images/rev-images/google.svg";
import Rquote from "../../../../Assets/images/rev-images/review-quote.svg";

import { base_url, postHeader } from "../../../../Helpers/request";
import { Link } from "@material-ui/core";
import {
  client_name,
} from "../../../../Helpers/request";

const Reviews = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  const [reviews, setReviews] = useState([]);
  const [totalReviewCount, setTotalReviewCount] = useState(0);
  const [averageRating, setAverageRating] = useState(0);

  const fetchReviews = useCallback(() => {
    axios
      .get(`${base_url}/common/site_reviews`, { headers: postHeader })
      .then(({ data }) => {
        if (data.status === 1) {
          setReviews(data.data || []);
          setTotalReviewCount(data.total_review_count || 0);
          setAverageRating(data.average_rating || 0);
        }
      })
      .catch((err) => console.error(err));
  }, []);



  useEffect(() => {
    fetchReviews();
  }, [fetchReviews]);

  const openReviewPopup = (review) => {
    setSelectedReview(review);
    setIsPopupOpen(true);
  };
  const settings2 = {
    accessibility: true,
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <LazyLoadImage src={leftArrow} alt="arrow" />,
    nextArrow: <LazyLoadImage src={rightArrow} alt="arrow" />,
    responsive: [
      { breakpoint: 1025, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="mreview_section">
      <Container className="showcase-container">
        <div className="mreview_section_inner">
          <Row>
            <Col lg={12}>
              <div className="text-center">
                {/* <Heading className="quote-heading text-center mb-0"> */}

                <h2>Real Reviews from Real People</h2>
                {/* </Heading> */}
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="mreview-header">
                <div className="mreview-info">
                  <div className="mreview-infocontent">
                    <div className="mreview-inforating">
                      <a href="https://www.google.com/search?client=firefox-b-d&hs=bwIq&sca_esv=85b946b4252f7f97&sxsrf=APpeQntefTtRqb-UvpxANRnrMU2ZK0zLsQ:1784718004674&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afu5mPG3OdVPSVp4OnG0tYESSubBguRZQ6y2WhI3n431bHi_kF51OMdOaJ-tV5ylrEsPy8ngdm-ya-CFNbBcYiLFzh2HnmybpkD9jX66t9UCm_VfOPQ%3D%3D&q=Morgan+Taylor+Jewelers+Reviews&sa=X&ved=2ahUKEwjRksXVkOaVAxXRTWwGHdIIF-AQ0bkNegQIKhAI&biw=1536&bih=827&dpr=1.25" target="_blank">
                        <img className="mreview-infogle" src={Google} alt="Google" /> <span>Reviews</span>
                      </a>
                    </div>
                    <div className="mreview-infostar">
                      <span className="rating-num">{averageRating || 0}</span>
                      <a href="https://www.google.com/search?client=firefox-b-d&hs=bwIq&sca_esv=85b946b4252f7f97&sxsrf=APpeQntefTtRqb-UvpxANRnrMU2ZK0zLsQ:1784718004674&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afu5mPG3OdVPSVp4OnG0tYESSubBguRZQ6y2WhI3n431bHi_kF51OMdOaJ-tV5ylrEsPy8ngdm-ya-CFNbBcYiLFzh2HnmybpkD9jX66t9UCm_VfOPQ%3D%3D&q=Morgan+Taylor+Jewelers+Reviews&sa=X&ved=2ahUKEwjRksXVkOaVAxXRTWwGHdIIF-AQ0bkNegQIKhAI&biw=1536&bih=827&dpr=1.25" target="_blank">
                        {"★".repeat(Math.round(reviews[0]?.averageReview || 0))}
                      </a>
                      <span className="info-num">({totalReviewCount || 0})</span>
                    </div>

                  </div>
                </div>
                <div className="mreview-btn">
                  <a href="https://www.google.com/search?client=firefox-b-d&hs=bwIq&sca_esv=85b946b4252f7f97&sxsrf=APpeQntefTtRqb-UvpxANRnrMU2ZK0zLsQ:1784718004674&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afu5mPG3OdVPSVp4OnG0tYESSubBguRZQ6y2WhI3n431bHi_kF51OMdOaJ-tV5ylrEsPy8ngdm-ya-CFNbBcYiLFzh2HnmybpkD9jX66t9UCm_VfOPQ%3D%3D&q=Morgan+Taylor+Jewelers+Reviews&sa=X&ved=2ahUKEwjRksXVkOaVAxXRTWwGHdIIF-AQ0bkNegQIKhAI&biw=1536&bih=827&dpr=1.25#lrd=0x80c8c0be22e29d4b:0xb309d2780c00d0ee,3,,,," target="_blank">
                    Leave a Review
                  </a>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="mreview_slider">
                <Slider className="mreview_say_inner" {...settings2}>
                  {reviews.map((item) => {
                    let images = [];

                    try {
                      images = item.images_json
                        ? JSON.parse(item.images_json)
                        : [];
                    } catch (error) {
                      console.error("Invalid images_json:", error);
                      images = [];
                    }

                    return (
                      <div className="mreview_slide_item" key={item.id}>
                        <div className="mreview-card">

                          {/* USER INFO */}
                          <div className="mreview-user-info">
                            <div className="mreview-user-left">
                              <div className="mreview-user-image">
                                <img loading="lazy"
                                  src={item.profile || "https://randomuser.me/api/portraits/men/1.jpg"}
                                  alt={item.username}
                                />
                                <img className="mstarimgsm" src={GoogleIcon} alt="Google" />
                              </div>

                              <div className="mreview-user-content">
                                <p>{item.username}</p>
                                <span>{item.publishAt}</span>
                              </div>
                            </div>

                            {/* <div className="mreview-google-icon">
                              <LazyLoadImage src={GoogleIcon} alt="Google" />
                            </div> */}
                          </div>

                          {/* STARS */}
                          <div className="mreview-stars">
                            {"★".repeat(Number(item.rating || 5))}
                          </div>

                          {/* REVIEW TEXT */}
                           <div className="mreview_desc">
                            <div className="mreview_text_wrapper">
                              <p className="mreview_text">
                                {item.review} 
                              </p>
                            </div>     

                            {item.review && item.review.length > 150 && (    
                              <span
                                className="mreview_read_more"
                                onClick={() => openReviewPopup(item)} 
                              >
                                Show More 
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </Col>
          </Row>
          {/* popup */}
          {isPopupOpen && selectedReview && (
            <div
              className="mreview-popup-overlay"
              onClick={() => setIsPopupOpen(false)}
            >
              <div
                className="mreview-popup"
                onClick={(e) => e.stopPropagation()}
              >


                <div className="mreview-card popup-card">
                  <div className="mreview-infotop">
                    {/* USER INFO */}
                    <div className="mreview-user-info">
                      <div className="mreview-user-left">

                        <div className="mreview-user-image">
                          <img
                            src={
                              selectedReview.profile ||
                              "https://randomuser.me/api/portraits/men/1.jpg"
                            }
                            alt={selectedReview.username}
                          />

                          <img
                            className="mstarimgsm"
                            src={GoogleIcon}
                            alt="Google"
                          />
                        </div>

                        <div className="mreview-user-content">
                          <p>{selectedReview.username}</p>
                          <span>{selectedReview.publishAt}</span>
                        </div>

                      </div>
                      <div className="mreview-btn">
                        <a
                          href="https://www.google.com/search?client=firefox-b-d&hs=bwIq&sca_esv=85b946b4252f7f97&sxsrf=APpeQntefTtRqb-UvpxANRnrMU2ZK0zLsQ:1784718004674&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afu5mPG3OdVPSVp4OnG0tYESSubBguRZQ6y2WhI3n431bHi_kF51OMdOaJ-tV5ylrEsPy8ngdm-ya-CFNbBcYiLFzh2HnmybpkD9jX66t9UCm_VfOPQ%3D%3D&q=Morgan+Taylor+Jewelers+Reviews&sa=X&ved=2ahUKEwjRksXVkOaVAxXRTWwGHdIIF-AQ0bkNegQIKhAI&biw=1536&bih=827&dpr=1.25#lrd=0x80c8c0be22e29d4b:0xb309d2780c00d0ee,3,,,,"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Leave a Review
                        </a>
                      </div>
                    </div>

                    {/* Rating */}
                    <div className="mreview-stars">
                      {"★".repeat(Number(selectedReview.rating || 5))}
                    </div>
                    <div className="mreview-btn mreview-btn-inr">
                      <a
                        href="https://www.google.com/search?client=firefox-b-d&hs=bwIq&sca_esv=85b946b4252f7f97&sxsrf=APpeQntefTtRqb-UvpxANRnrMU2ZK0zLsQ:1784718004674&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afu5mPG3OdVPSVp4OnG0tYESSubBguRZQ6y2WhI3n431bHi_kF51OMdOaJ-tV5ylrEsPy8ngdm-ya-CFNbBcYiLFzh2HnmybpkD9jX66t9UCm_VfOPQ%3D%3D&q=Morgan+Taylor+Jewelers+Reviews&sa=X&ved=2ahUKEwjRksXVkOaVAxXRTWwGHdIIF-AQ0bkNegQIKhAI&biw=1536&bih=827&dpr=1.25#lrd=0x80c8c0be22e29d4b:0xb309d2780c00d0ee,3,,,,"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Leave a Review
                      </a>
                    </div>
                    <button
                      className="mreview-popup-close"
                      onClick={() => setIsPopupOpen(false)}
                    >
                      ×
                    </button>
                  </div>

                  {/* Review */}
                  <div className="mreview_desc">
                    {/* <p>{selectedReview.review}</p> */}
                    <p
                      dangerouslySetInnerHTML={{ __html: selectedReview.review }}
                    />
                  </div>

                </div>
              </div>
            </div>
          )}
          {/* popup */}
        </div>
      </Container>



    </section>
  );
};

export default Reviews;